import { Page } from '@ui/themed';
import { t } from 'i18next';
import { useHandlers, withPageProviders } from '../../../context/page-context';
import { CompaniesSearchTable } from '../components/companies-search-table';

export const CompaniesPage = withPageProviders(CompaniesPageContent);

function CompaniesPageContent() {
  const { navigationHandler } = useHandlers();

  return (
    <Page
      title={t('features:companies.pages.companies_list_page.title')}
      description={t('features:companies.pages.companies_list_page.description')}
      primaryAction={{
        label: t('features:companies.pages.companies_list_page.create_button'),
        onClick: () => navigationHandler.navigate('/customers/companies/create'),
      }}
    >
      <CompaniesSearchTable />
    </Page>
  );
}
